import HistoryHelper from "./historyHelper";

window.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelector("#rental")) {
    return;
  }

  HistoryHelper.saveVisitedItem(
    document.querySelector("#rental").getAttribute("data-id")
  );
});
